import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { APP_ENVIRONMENT } from '@app/shared/tokens';
import { provideToastr } from 'ngx-toastr';

import { environment } from '../environments/environment';
import { CredentialsInterceptor } from '../interceptors/credentials-interceptor.service';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(appRoutes),
        provideNativeDateAdapter(),
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideToastr({
            countDuplicates: true,
            preventDuplicates: true,
            resetTimeoutOnDuplicate: true,
            maxOpened: 5,
        }),
        {
            provide: APP_ENVIRONMENT,
            useValue: environment,
        },

        ...(environment.production ? [{ provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true }] : []),
    ],
};

